export default {
  role: {
    admin: 'admin',
    ks: 'ks',
    external: 'external',
    ksDeptAdmin: 'ksDeptAdmin',
  },
};
